<div class="container max-w-5xl mx-auto">
  <div *ngIf="showAlert" class="alert-warning relative">
    <ng-icon
      name="hero-information-circle-mini"
      size="24"
      class="text-gray-light"
    ></ng-icon>
    <div class="md:ml-12 flex flex-col flex-1 text-center">
      <span>{{ 'terms.alert.info' | translate }}</span>
    </div>
    <button class="button-sm" (click)="signTerms()">
      {{ 'terms.alert.sign' | translate }}
    </button>
  </div>
</div>
